import { render, staticRenderFns } from "./template-table.vue?vue&type=template&id=26839601"
import script from "./template-table.vue?vue&type=script&lang=js"
export * from "./template-table.vue?vue&type=script&lang=js"
import style0 from "./template-table.vue?vue&type=style&index=0&id=26839601&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports